<template>
  <v-dialog
    v-model="isOpen"
    max-width="600px"
    persistent
  >
    <v-card>
      <v-card-title>Добавление проекта пользователю {{user}}</v-card-title>
      <v-card-text>
        <v-form v-model="valid">
          <v-select
            required
            multiple
            :items="innerProjects"
            item-text="label"
            item-value="project"
            v-model="selectedProjects"
            label="Проекты"
            :rules="[required]"
          ></v-select>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="isOpenInner = !isOpenInner">Отмена</v-btn>
        <v-btn text color="success" @click="addRoleUser" :disabled="!valid">Добавить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import asyncQuery from "../../../asyncQuery";

  export default {
    name: "AddRoleUser",
    data: () => {
      return {
        valid: false,
        selectedProjects: [],
      }
    },
    props: {
      isOpen: Boolean,
      user: String,
      toggleRoleUserDialog: Function,
      alreadyIncludedProjects: Array,
      getUsers: Function,
      toggleLoading: Function,
      projects: Array,
      getProjects: Function,
    },
    computed: {
      isOpenInner: {
        get: function () {
          return this.isOpen;
        },
        set: function () {
          this.selectedProjects = [];
          this.toggleRoleUserDialog();
        }
      },
      innerProjects: function () {
        const projects = this.projects
          .filter(el => !new Set([...this.alreadyIncludedProjects]).has(el.project));
        return Object.keys(projects).reduce((ac, idx) =>
          [...ac, {project: projects[idx].project, label: projects[idx].label,}], []
        )
      }
    },
    methods: {
      required: value => !!value.length || 'Это обязательное поле.',

      addRoleUser: function () {
        asyncQuery.bind(this)({
          url: '/api/add_role_user',
          method: 'POST',
          body: JSON.stringify({
            user: this.user,
            roles: this.selectedProjects,
          }),
          handleSuccess: () => {
            this.selectedProjects = [];
            this.toggleRoleUserDialog();
            this.getUsers();
          }
        })
      },
    },
  }
</script>

<style scoped>

</style>
